import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { PrefixEvent } from "src/app/components/global/prefixes/prefix.component";
import { DefaultComponent } from "src/app/default.component";
import { TableField } from "../table-field";
import { TableGroup } from "../table-group";
import { TableHeader } from "../table-header";
import { TableRow } from "../table-row";
import { TableOptions } from "../table.interface";

export type EditEvent = { contentId: string; row: TableRow; field: TableField; type: "REQUEST" | "SUBMIT" };

@Component({
  selector: "app-table-view",
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: "",
})
export class TableViewComponent extends DefaultComponent implements OnInit {
  @Input({ required: true })
  public root: TableGroup;

  @Input({ required: true })
  public headers: TableHeader[];

  @Input({ required: true })
  public options: TableOptions;

  @Output()
  public rowSelection: EventEmitter<void>;
  @Output()
  public prefixEvent: EventEmitter<[PrefixEvent, TableRow]>;
  @Output()
  public sort: EventEmitter<TableHeader>;
  @Output()
  public editEvent: EventEmitter<EditEvent>;

  public constructor() {
    super();
    this.root = new TableGroup("");
    this.headers = [];
    this.editEvent = new EventEmitter();
    this.options = {
      head: true,
      foot: true,
      delete: false,
      archive: false,
      add: false,
      download: false,
      search: true,
      selectable: false,
      type: "DEFAULT",
      filter: false,
      map: false,
      tile: false,
      pageSize: 0,
      layout: null,
    };
    this.rowSelection = new EventEmitter();
    this.prefixEvent = new EventEmitter();
    this.sort = new EventEmitter();
  }

  public ngOnInit(): void {
    this.sortColumns();
  }

  protected getAllRows(root: TableGroup | null = this.root): TableRow[] {
    if (!root) return [];
    const rows: TableRow[] = [];
    rows.push(...root.rows);

    for (const group of root.groups) {
      rows.push(...this.getAllRows(group));
    }

    return rows;
  }

  protected sortColumns(): void {}
}
